import * as React from 'react';

import { useTranslation } from 'react-i18next';

import bannerImg from '@assets/images/nomad/quests_banner.webp';

import { Button } from '@components/button';

import * as Styled from './quests.styled';

const Quests = () => {
	const { t } = useTranslation('nomad');

	return (
		<Styled.Wrapper>
			<Styled.Content>
				<Styled.Title>{t('home_title_3')}</Styled.Title>
				<Styled.Description>{t('home_desc_3')}</Styled.Description>
				<Styled.LinkStyled to={'/quests'}>
					<Button color='primary'>{t('home_btn_3')}</Button>
				</Styled.LinkStyled>
			</Styled.Content>
			<Styled.ImageWrapper>
				<img src={bannerImg} alt='quests banner' />
			</Styled.ImageWrapper>
		</Styled.Wrapper>
	);
};

export default Quests;
